import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-right",
  "use": "icon-right-usage",
  "viewBox": "0 0 13 12",
  "content": "<symbol viewBox=\"0 0 13 12\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-right\">\r\n<path d=\"M1.00012 5.98052L5.41397 10.8543\" stroke=\"#39B38E\" stroke-width=\"2\" stroke-linecap=\"round\" />\r\n<path d=\"M11.8987 1.22266L5.41382 10.8543\" stroke=\"#39B38E\" stroke-width=\"2\" stroke-linecap=\"round\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol